import * as types from './types'
import {
  ToolBookStatementBookAdditionalListModel,
  ToolStatementStudentAddBookCatalog
} from 'src/model/AdminModel'

export default {
  actionToolBookStatementBookAdditionalListModel({state,commit},query){
    if(state.bookAdditionalListModel.state === 'loading'){
      return Promise.reject('err');
    }
    commit(types.STUDENT_BOOK_ADDITION,{
      state:'loading'
    });
    return ToolBookStatementBookAdditionalListModel.getInstance().execute(query).then((response) => {
      commit(types.STUDENT_BOOK_ADDITION,{
        ...response,
        state: 'loadend'
      });
      return response;
    }).catch((err) => {
      commit(types.STUDENT_BOOK_ADDITION,{
        state: 'loaderr'
      });
      return Promise.reject(err);
    })
  },
  actionToolStatementsStudentAddBookCatalog({commit},query){
    return ToolStatementStudentAddBookCatalog.getInstance().execute(query);
  }
}



// WEBPACK FOOTER //
// ./src/store/Admin/modules/studentBookAddition/actions.js